import { z } from '@harvestiq/zod';
import { dbPolicySchema } from './db-policy';

export const getPolicyResponseSchema = z.object({
  data: z.array(dbPolicySchema),
});

export type GetPolicyResponse = z.infer<typeof getPolicyResponseSchema>;
